import { UserProfile } from '../../../__generated__/GQL';
import locales from './locales';

const formatTitle = (user: Pick<UserProfile, 'gender' | 'lastName'>) => {
  return locales.formatString(
    user.gender === 'female'
      ? locales.legalTitleFemale
      : locales.legalTitleMale,
    user.lastName || '',
  );
};

export default formatTitle;
